const transitDelaySlabTypes = {
  FIXED: 'FIXED',
  PERCENTAGE_ON_BASE_FREIGHT: 'PERCENTAGE_ON_BASE_FREIGHT',
};


module.exports = {
  transitDelaySlabTypes,
};
